<div appearance="outlined" class="coll-themed-class container-height full-width no-shadow no-background">
    <div id="dicom-patient-details">
        <form [formGroup]="patientDataForm" class="custom-col-class col-sm-6 form">
            <h3>{{ "ToolUploadRegistryPatient" | translate }}</h3>
            <div class="coll-themed-class border-1-solid margin-bottom-7-important flex-input-container">
                <div>
                    <mat-form-field
                        [hideRequiredMarker]="true"
                        appearance="outline"
                        class="se-form-field form-input-field"
                    >
                        <mat-label [ngClass]="{ 'label-color': isDisabled('issuer') }">{{
                            "Issuer" | translate
                        }}</mat-label>
                        <input formControlName="issuer" id="issuer" matInput />
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field
                        [hideRequiredMarker]="true"
                        appearance="outline"
                        class="se-form-field form-input-field"
                    >
                        <mat-label [ngClass]="{ 'label-color': isDisabled('patientId') }">{{
                            "PatientIdentifier" | translate
                        }}</mat-label>
                        <input
                            [placeholder]="'PatientIdentifier' | translate"
                            formControlName="patientId"
                            id="patientId"
                            matInput
                        />
                    </mat-form-field>
                </div>

                <div>
                    <mat-form-field
                        [hideRequiredMarker]="true"
                        appearance="outline"
                        class="se-form-field form-input-field"
                    >
                        <mat-label [ngClass]="{ 'label-color': isDisabled('name') }">{{
                            "FirstName" | translate
                        }}</mat-label>
                        <input [placeholder]="'FirstName' | translate" formControlName="name" id="name" matInput />
                    </mat-form-field>
                </div>

                <div>
                    <mat-form-field
                        [hideRequiredMarker]="true"
                        appearance="outline"
                        class="se-form-field form-input-field"
                    >
                        <mat-label [ngClass]="{ 'label-color': isDisabled('surname') }">{{
                            "LastName" | translate
                        }}</mat-label>
                        <input [placeholder]="'LastName' | translate" formControlName="surname" id="surname" matInput />
                    </mat-form-field>
                </div>

                <div>
                    <mat-form-field
                        [hideRequiredMarker]="true"
                        appearance="outline"
                        class="se-form-field form-input-field"
                    >
                        <mat-label [ngClass]="{ 'label-color': isDisabled('sex') }">{{ "Sex" | translate }}</mat-label>
                        <input [placeholder]="'Sex' | translate" formControlName="sex" id="sex" matInput />
                    </mat-form-field>
                </div>

                <div>
                    <mat-form-field
                        [hideRequiredMarker]="true"
                        appearance="outline"
                        class="se-form-field form-input-field"
                    >
                        <mat-label [ngClass]="{ 'label-color': isDisabled('birthDate') }">{{
                            "BirthDate" | translate
                        }}</mat-label>
                        <input [matDatepicker]="picker" formControlName="birthDate" matInput />
                        <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
                        <mat-datepicker #picker typeof="date"></mat-datepicker>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field
                        [hideRequiredMarker]="true"
                        appearance="outline"
                        class="se-form-field form-input-field"
                    >
                        <mat-label [ngClass]="{ 'label-color': isDisabled('accessionNumber') }">{{
                            "Accession_Number" | translate
                        }}</mat-label>
                        <input
                            [placeholder]="'Accession_Number' | translate"
                            formControlName="accessionNumber"
                            id="accessionNumber"
                            matInput
                        />
                    </mat-form-field>
                </div>
                <div *ngIf="isVNA">
                    <mat-form-field
                        [hideRequiredMarker]="true"
                        appearance="outline"
                        class="se-form-field form-input-field"
                    >
                        <mat-label [ngClass]="{ 'label-color': isDisabled('businessUnit') }">{{
                            "OrderBusinessUnit" | translate
                        }}</mat-label>
                        <div>
                            <mat-select formControlName="businessUnit" id="businessUnit">
                                <mat-option *ngFor="let option of options" [value]="option">{{
                                    option.description
                                }}</mat-option>
                            </mat-select>
                        </div>
                    </mat-form-field>
                </div>
            </div>
        </form>
    </div>
</div>
